var map = {
	"./certificacion.png": "3794",
	"./comercial.png": "519b",
	"./holografica.png": "1fc4",
	"./innominada.png": "42d6",
	"./mixtas.png": "ec71",
	"./nominativas.png": "eae0",
	"./olfativa.png": "7c18",
	"./sonoras.png": "7646",
	"./tridimensionales.png": "b624"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "f387";